import {
  BASIC_DARK_GRAY,
  BASIC_LIGHT_BLUE,
  BASIC_WHITE,
} from "../constants/colors";

export default function IconHeart() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="21.221"
      viewBox="0 0 24 21.221"
    >
      <g
        id="グループ_1168"
        data-name="グループ 1168"
        transform="translate(-5560.5 -1956.493)"
      >
        <path
          id="パス_104"
          data-name="パス 104"
          d="M124.552,172.285l9.473-9.473c2.616-2.616,2.787-7.04,0-9.473-2.325-2.031-6.563-2.239-9.473,1.832-2.91-4.071-7.148-3.863-9.473-1.832-2.787,2.433-2.616,6.857,0,9.473l9.473,9.473"
          transform="translate(5447.948 1805.075)"
          fill={BASIC_LIGHT_BLUE}
        />
        <path
          id="パス_105"
          data-name="パス 105"
          d="M124.552,172.285l9.473-9.473c2.616-2.616,2.787-7.04,0-9.473-2.325-2.031-6.563-2.239-9.473,1.832-2.91-4.071-7.148-3.863-9.473-1.832-2.787,2.433-2.616,6.857,0,9.473l9.473,9.473"
          transform="translate(5447.948 1805.075)"
          fill={BASIC_WHITE}
        />
        <path
          id="パス_106"
          data-name="パス 106"
          d="M124.552,172.285l9.473-9.473c2.616-2.616,2.787-7.04,0-9.473-2.325-2.031-6.563-2.239-9.473,1.832-2.91-4.071-7.148-3.863-9.473-1.832-2.787,2.433-2.616,6.857,0,9.473l9.473,9.473"
          transform="translate(5447.948 1805.075)"
          fill="none"
          stroke={BASIC_DARK_GRAY}
          strokeWidth="1"
        />
      </g>
    </svg>
  );
}
